export default {"src":"/_next/static/media/fil.71d619f1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};